import script from "./ApplicationLandingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationLandingView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationLandingView.vue?vue&type=style&index=0&id=738cd274&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_new_core_update\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738cd274"]])

export default __exports__